var render = function render(){var _vm=this,_c=_vm._self._c;return _c('no-active-subs',{attrs:{"product-type":"adopt"},on:{"logout":_vm.logout,"navigateToProduct":_vm.navigateToEngage},scopedSlots:_vm._u([{key:"logo",fn:function(){return [_vm._t("logo")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }